import { Flex } from "@mantine/core";

import { ProductSaleFlowWrapper } from "./ProductSaleFlowWrapper";

export function ProductSaleFlowPanel() {
    return (
        <Flex pos={"absolute"} inset={0} bg="dark.7">
            <ProductSaleFlowWrapper />
        </Flex>
    );
}
